module.exports = __webpack_public_path__ + "static/media/an.356f0d97.svg";